module.exports = __webpack_public_path__ + "img/share-icon.7870ca8c.svg";